module.exports = __webpack_public_path__ + "static/allerta-arancione-13b7c628c24fb96356fccfc35b850b3c.png";